import React, { useState, useEffect, useRef } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { FooterMultiStepProgress } from '../../step-navigation/footerMultiStepProgress';

import { COB_API_TYPE } from '../../../types/online-forms.types';

// eslint-disable-next-line import/no-named-as-default
import useCobStore from '../../../store/cob-store';

import {
  EntitlementReason,
  MedicareCoverage,
  SSNDisability,
  MedicareSectionDivider,
  MedicarePartA,
  MedicarePartB,
  MedicarePartC,
  MedicarePartD,
} from './index';
import { FormInstruction } from '../form-instruction/form-instruction';

export function MedicareQuestioner(props: any) {
  // eslint-disable-next-line no-empty-pattern
  const navigate = useNavigate();
  const { hideClose, partnerToken } = props;

  const [isErrorHandling, setErrorHandling] = useState<boolean>(false);
  const [isValidateForm, setIsValidateForm] = useState<boolean>(false);
  const [isNextDisabled, setIsNextDisabled] = useState<boolean>(false);
  const [isValidPCN, setIsValidPCN] = useState<boolean>(false);

  const cobResponse = useCobStore((state: any) => state.cobInformation);
  const dependentsList = useCobStore((state: any) => state.dependents);
  const demographics = useCobStore((state: any) => state.demographics);

  const checkClose = hideClose === 'false' ? hideClose : 'true';

  const closeCOBForm = () => {
    navigate(-1);
  };

  useEffect(() => {}, [cobResponse, dependentsList]);
  let defaultComponent: JSX.Element[] = [];
  const childRef = useRef<any>();

  const formInstruction: Array<any> = [
    <FormInstruction
      nextButtonClicked={isValidateForm}
      errorHandling={(val: boolean) => setErrorHandling(val)}
      hideClose={checkClose}
      showFooter="false"
      showContinue="true"
      startValue="0"
    />,
  ];
  const dependentName = useRef<HTMLInputElement>(null);
  const medicareDivider: Array<any> = [
    <MedicareSectionDivider
      showFooter="true"
      name={dependentName}
      hideClose={checkClose}
      errorHandling={() => setErrorHandling(true)}
    />,
  ];

  const setMedicareFlowComponent = (medicareInsurance: any) => {
    const medicareSectionComponent = [
      <MedicareCoverage
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        startNow="false"
        ref={childRef}
      />,
      <EntitlementReason
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        ref={childRef}
      />,
      <SSNDisability
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        ref={childRef}
      />,
      <MedicarePartA
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        ref={childRef}
      />,
      <MedicarePartB
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        ref={childRef}
      />,
      <MedicarePartC
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        ref={childRef}
      />,
      <MedicarePartD
        OPISResponseInfo={medicareInsurance}
        nextButtonClicked={isValidateForm}
        errorHandling={(val: boolean) => setErrorHandling(val)}
        nextDisabled={(val: boolean) => setIsNextDisabled(val)}
        hideClose={checkClose}
        showFooter="true"
        ref={childRef}
        partPCNBIN="true"
        isValidPCN={(val: boolean) => setIsValidPCN(val)}
        partnerToken={partnerToken}
      />,
    ];
    return medicareSectionComponent;
  };

  let componentList: any = [];

  const checkIsAnyDependentOptedMedicare = cobResponse?.medicare?.filter(
    (item: any) => item.hasMedicare === 'Y',
  );

  const hasDependentsList = () => {
    const dependentsOtherInsurance = cobResponse.additionalInsurance.filter(
      (item: any) => item.hasAdditionalInsurance === 'Y',
    );
    if (
      cobResponse?.medicare[0]?.hasMedicare === 'N' &&
      checkIsAnyDependentOptedMedicare?.length > 0
    ) {
      let noContracterMedicareInsurance: any = [];

      let dependents = cobResponse.medicare.filter(
        (item: any) => item.hasMedicare === 'Y',
      );
      dependents = dependents.sort((a: any, b: any) =>
        a.member.firstName.localeCompare(b.member.firstName),
      );
      noContracterMedicareInsurance = [...dependents];
      let nextOtherDep = 0;
      for (
        let i: number = 0;
        i <= noContracterMedicareInsurance.length - 1;
        i += 1
      ) {
        if (i === 0 && dependentsOtherInsurance.length === 0) {
          componentList.push(...formInstruction);
        }
        nextOtherDep = i;
        defaultComponent = setMedicareFlowComponent(
          noContracterMedicareInsurance[i],
        );
        if (i !== noContracterMedicareInsurance.length - 1) {
          const medicareSecDivider = [
            <MedicareSectionDivider
              showFooter="true"
              hideClose={checkClose}
              errorHandling={() => setErrorHandling(true)}
              name={[
                `${
                  noContracterMedicareInsurance[nextOtherDep + 1].member
                    .firstName
                } 's`,
              ]}
            />,
          ];
          componentList.push(...defaultComponent, ...medicareSecDivider);
        } else {
          componentList.push(...defaultComponent);
        }
        // }
      }
    } else if (
      cobResponse.medicare[0]?.hasMedicare === 'Y' &&
      checkIsAnyDependentOptedMedicare.length === 1
    ) {
      // eslint-disable-next-line no-plusplus
      for (let i: number = 0; i < cobResponse.medicare.length; i += 1) {
        componentList = [];
        defaultComponent = setMedicareFlowComponent(cobResponse.medicare[i]);
        if (i === 0 && dependentsOtherInsurance.length === 0) {
          componentList.push(...formInstruction, ...defaultComponent);
        } else {
          componentList.push(...medicareDivider, ...defaultComponent);
        }
      }
    } else if (
      cobResponse.medicare[0].hasMedicare === 'Y' &&
      checkIsAnyDependentOptedMedicare.length > 1
    ) {
      if (checkIsAnyDependentOptedMedicare.length > 1) {
        let finalArray: any = [];
        const contractor = cobResponse.medicare.find(
          (item: any) =>
            item.member.firstName === demographics?.demographics.firstName,
        );
        const dependents = cobResponse.medicare.filter(
          (item: any) =>
            (item.member.firstName !== demographics?.demographics.firstName ||
              item.member.firstName === demographics.demographics.firstName) &&
            item.member.dateOfBirth !== demographics.demographics.dateOfBirth &&
            item.hasMedicare === 'Y',
        );

        finalArray = [contractor, ...dependents];
        for (let i = 0; i <= finalArray.length - 1; i += 1) {
          defaultComponent = setMedicareFlowComponent(finalArray[i]);
          const nextOtherDep = i;
          let divderFirstSec: Array<any> = [];
          if (i === 0 && dependentsOtherInsurance.length === 0) {
            componentList.push(...formInstruction);
          }
          if (nextOtherDep < finalArray.length - 1) {
            divderFirstSec = [
              <MedicareSectionDivider
                showFooter="true"
                errorHandling={() => setErrorHandling(true)}
                hideClose={checkClose}
                name={[`${finalArray[nextOtherDep + 1].member.firstName} 's`]}
              />,
            ];
          }
          componentList.push(...defaultComponent, ...divderFirstSec);
        }
      } else {
        const demographicData = cobResponse.medicare.find(
          (item: any) =>
            item.member.firstName === demographics?.demographics.firstName,
        );
        defaultComponent = setMedicareFlowComponent(demographicData);
        if (dependentsOtherInsurance.length === 0) {
          componentList.push(...formInstruction);
        }
        componentList.push(
          <MedicareSectionDivider
            showFooter="true"
            name={dependentName}
            hideClose={checkClose}
            canNavigateBack="true"
            errorHandling={() => setErrorHandling(true)}
          />,
          ...defaultComponent,
        );
      }
    }
  };

  // eslint-disable-next-line no-empty-pattern
  const [] = useState({
    medicareForm: hasDependentsList(),
  });

  // }
  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', minHeight: '100vh' }}
    >
      <FooterMultiStepProgress
        list={componentList}
        handleFormOrNext={isErrorHandling}
        isValidateForm={(val: boolean) => setIsValidateForm(val)}
        closeForm={closeCOBForm}
        formName={COB_API_TYPE.OTHER_INSURANCE}
        isNextDisabled={isNextDisabled}
        isChildRef={childRef}
        isValidPCN={isValidPCN}
        partnerToken={partnerToken}
      />
    </StackLayout>
  );
}
